module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/report-2d756f857ea5307e993d6219ca2b9416.png";